// Products Data for Handmade Haven
import { getOptimizedImage } from '../utils/imageUtils';

export const products = [
  {
    "id": "resin",
    "product_id": 1,
    "name": "Resin",
    "slug": "resin",
    "type": "variant",
    "category": "Resin",
    "image": "/Updated Products Images/2_1 Resin 300gm 300₹ 1.5gm 1100₹ .webp",
    "description": "High-quality epoxy resin for premium resin art and DIY projects.",
    "shortDescription": "High-quality epoxy resin for premium resin art.",
    "variants": [
      { "label": "300gm", "price": 300 },
      { "label": "1.5kg", "price": 1100 }
    ]
  },
  {
    "id": "uv-resin",
    "product_id": 2,
    "name": "UV Resin",
    "slug": "uv-resin",
    "type": "variant",
    "category": "Resin",
    "image": "/Updated Products Images/Uv resin 50gm 230₹.  100gm. 350₹.webp",
    "description": "Fast-curing UV resin ideal for jewelry, charms, and quick projects.",
    "shortDescription": "Fast-curing UV resin for quick projects.",
    "variants": [
      { "label": "10gm", "price": 80, "image": "/Updated Products Images/Uv resin 10gm.  80₹.webp" },
      { "label": "50gm", "price": 230, "image": "/Updated Products Images/Uv resin 50gm 230₹.  100gm. 350₹.webp" },
      { "label": "100gm", "price": 350, "image": "/Updated Products Images/Uv resin 50gm 230₹.  100gm. 350₹.webp" }
    ]
  },
  {
    "id": "agate-mould",
    "product_id": 3,
    "name": "Agate Mould",
    "slug": "agate-mould",
    "type": "size",
    "category": "Moulds",
    "image": "/Updated Products Images/4 inch agate mould 80₹.webp",
    "description": "Natural agate-style moulds for coasters and resin decor.",
    "shortDescription": "Natural agate-style moulds.",
    "sizes": [
      { "label": "2 inch", "price": 49 },
      { "label": "4 inch", "price": 80 },
      { "label": "6 inch", "price": 120 },
      { "label": "8 inch", "price": 170 }
    ]
  },
  {
    "id": "rose-preserve-mould",
    "product_id": 6,
    "name": "Rose Preserve Mould",
    "slug": "rose-preserve-mould",
    "type": "size",
    "category": "Moulds",
    "image": "/Updated Products Images/Rose preserve mould 150₹ 4 inch.webp",
    "description": "Elegant rose preservation mould for floral resin art.",
    "shortDescription": "Elegant rose preservation mould.",
    "sizes": [
      { "label": "4 inch", "price": 150 }
    ]
  },
  {
    "id": "square-mould",
    "product_id": 7,
    "name": "Square Mould",
    "slug": "square-mould",
    "type": "size",
    "category": "Moulds",
    "image": "/Updated Products Images/Square mould (2inch) 80₹.webp",
    "description": "Square silicone mould suitable for small resin projects.",
    "shortDescription": "Square silicone mould.",
    "sizes": [
      { "label": "2 inch", "price": 80 }
    ]
  },
  {
    "id": "jewellery-mould",
    "product_id": 15,
    "name": "Jewellery Mould",
    "slug": "jewellery-mould",
    "type": "single",
    "category": "Moulds",
    "price": 130,
    "image": "/Updated Products Images/Jewellery mould 130₹.webp",
    "description": "Mould for earrings, pendants, and jewelry items.",
    "shortDescription": "Mould for earrings, pendants, and jewelry."
  },
  {
    "id": "pop-socket-mould",
    "product_id": 19,
    "name": "Pop Socket Mould",
    "slug": "pop-socket-mould",
    "type": "single",
    "category": "Moulds",
    "price": 120,
    "image": "/Updated Products Images/Pop socket mould 120₹.webp",
    "description": "Mould for creating custom pop sockets.",
    "shortDescription": "Mould for custom pop sockets."
  },
  {
    "id": "alphabet-mould",
    "product_id": 33,
    "name": "Alphabet Mould",
    "slug": "alphabet-mould",
    "type": "single",
    "category": "Moulds",
    "price": 170,
    "image": "/Updated Products Images/New folder (2)/New Moulds/Alphabet mould 170₹.webp",
    "description": "High-quality alphabet mould for personalized resin creations.",
    "shortDescription": "Alphabet mould for personalized creations."
  },
  {
    "id": "butterfly-riyal-mould",
    "product_id": 34,
    "name": "Butterfly Riyal Mould",
    "slug": "butterfly-riyal-mould",
    "type": "single",
    "category": "Moulds",
    "price": 550,
    "image": "/Updated Products Images/New folder (2)/New Moulds/Butterfly riyal mould 550₹.webp",
    "description": "Premium Butterfly Riyal Mould set (2pc) for intricate designs.",
    "shortDescription": "Premium Butterfly Riyal Mould set (2pc)."
  },
  {
    "id": "butterfly-mould",
    "product_id": 35,
    "name": "Butterfly Mould",
    "slug": "butterfly-mould",
    "type": "single",
    "category": "Moulds",
    "price": 140,
    "image": "/Updated Products Images/New folder (2)/New Moulds/Butterfly mould 140₹.webp",
    "description": "Beautiful butterfly mould for resin art and decoration.",
    "shortDescription": "Beautiful butterfly mould for resin art."
  },
  {
    "id": "circle-keychain-mold",
    "product_id": 36,
    "name": "Circle Keychain Mold",
    "slug": "circle-keychain-mold",
    "type": "single",
    "category": "Moulds",
    "price": 240,
    "image": "/Updated Products Images/New folder (2)/New Moulds/Circle keychain mould 240₹.webp",
    "description": "Perfect circle mould for creating resin keychains.",
    "shortDescription": "Perfect circle mould for keychains."
  },
  {
    "id": "heart-mould",
    "product_id": 37,
    "name": "Heart Mould",
    "slug": "heart-mould",
    "type": "single",
    "category": "Moulds",
    "price": 120,
    "image": "/Updated Products Images/Heart mould 120₹.webp",
    "description": "Classic heart-shaped mould for romantic resin gifts.",
    "shortDescription": "Classic heart-shaped mould."
  },
  {
    "id": "tray-mould",
    "product_id": 38,
    "name": "Tray Mould",
    "slug": "tray-mould",
    "type": "size",
    "category": "Moulds",
    "image": "/Updated Products Images/New folder (2)/New Moulds/Tray mould 300₹.webp",
    "description": "Rectangular tray mould for serving platters and decor.",
    "shortDescription": "Rectangular tray mould.",
    "sizes": [
      { "label": "3x12 inch", "price": 300 }
    ]
  },
  {
    "id": "uneven-mould",
    "product_id": 39,
    "name": "Uneven Mould",
    "slug": "uneven-mould",
    "type": "single",
    "category": "Moulds",
    "price": 250,
    "image": "/Updated Products Images/New folder (2)/New Moulds/Uneven molud 250₹.webp",
    "description": "Artistic uneven mould for unique, abstract resin pieces.",
    "shortDescription": "Artistic uneven mould for unique pieces."
  },
  {
    "id": "wooden-stand",
    "product_id": 4,
    "name": "Wooden Stand",
    "slug": "wooden-stand",
    "type": "size",
    "category": "Stands",
    "image": "/Updated Products Images/Wooden stand (6inch&7inch  50₹. ) 4inch&5 inch 40₹.   8 & 9 inch 80₹.webp",
    "description": "Premium wooden display stands for resin art and frames.",
    "shortDescription": "Premium wooden display stands.",
    "sizes": [
      { "label": "4–5 inch", "price": 40 },
      { "label": "6–7 inch", "price": 50 },
      { "label": "8–9 inch", "price": 80 }
    ]
  },
  {
    "id": "metal-stand",
    "product_id": 5,
    "name": "Metal Stand",
    "slug": "metal-stand",
    "type": "size",
    "category": "Stands",
    "image": "/Updated Products Images/Metal stand 80₹ 4 inch  6 inch 120₹. 8 inch 160₹.webp",
    "description": "Strong metal stands for heavy resin pieces and display plates.",
    "shortDescription": "Strong metal stands for heavy pieces.",
    "sizes": [
      { "label": "4 inch", "price": 80 },
      { "label": "6 inch", "price": 120 },
      { "label": "8 inch", "price": 160 }
    ]
  },
  {
    "id": "hoop-stand",
    "product_id": 31,
    "name": "Hoop Stand",
    "slug": "hoop-stand",
    "type": "size",
    "category": "Stands",
    "image": "/Updated Products Images/New folder/Hoop stand 10inch 240₹.webp",
    "description": "Sturdy Hoop Stand for displaying resin art plates.",
    "shortDescription": "Sturdy Hoop Stand for displaying plates.",
    "sizes": [
      { "label": "10 inch", "price": 240 }
    ]
  },
  {
    "id": "bubble-buster",
    "product_id": 8,
    "name": "Bubble Buster",
    "slug": "bubble-buster",
    "type": "single",
    "category": "Essential",
    "price": 90,
    "image": "/Updated Products Images/Bubble buster 90₹.webp",
    "description": "Helps remove air bubbles from resin for a smooth finish.",
    "shortDescription": "Helps remove air bubbles from resin."
  },
  {
    "id": "deburring-tool",
    "product_id": 9,
    "name": "Deburring Tool",
    "slug": "deburring-tool",
    "type": "single",
    "category": "Essential",
    "price": 110,
    "image": "/Updated Products Images/Deburring tool 110₹.webp",
    "description": "Perfect for smoothing sharp resin edges.",
    "shortDescription": "Perfect for smoothing sharp edges."
  },
  {
    "id": "drill-machine",
    "product_id": 10,
    "name": "Mini Drill Machine",
    "slug": "drill-machine",
    "type": "single",
    "category": "Essential",
    "price": 499,
    "image": "/Updated Products Images/Drill machine 499₹.webp",
    "description": "Compact drill for resin jewelry and precision work.",
    "shortDescription": "Compact drill for resin jewelry."
  },
  {
    "id": "fairy-light",
    "product_id": 12,
    "name": "Fairy Light",
    "slug": "fairy-light",
    "type": "single",
    "category": "Essential",
    "price": 30,
    "image": "/Updated Products Images/Fairy light 30₹.webp",
    "description": "Decorative fairy lights for artistic displays.",
    "shortDescription": "Decorative fairy lights."
  },
  {
    "id": "dry-flowers",
    "product_id": 11,
    "name": "Dry Flowers",
    "slug": "dry-flowers",
    "type": "single",
    "category": "Essential",
    "price": 180,
    "image": "/Updated Products Images/Dry flowers 180₹.webp",
    "description": "Preserved flowers for resin art and decoration.",
    "shortDescription": "Preserved flowers for resin art."
  },
  {
    "id": "golden-flakes",
    "product_id": 13,
    "name": "Golden Flakes",
    "slug": "golden-flakes",
    "type": "single",
    "category": "Essential",
    "price": 50,
    "image": "/Updated Products Images/Golden flakes 50₹.webp",
    "description": "Metallic flakes to enhance resin artwork.",
    "shortDescription": "Metallic flakes to enhance artwork."
  },
  {
    "id": "heat-gun",
    "product_id": 14,
    "name": "Heat Gun",
    "slug": "heat-gun",
    "type": "single",
    "category": "Essential",
    "price": 480,
    "image": "/Updated Products Images/Heat gun 480₹.webp",
    "description": "Used to remove bubbles and smooth resin surfaces.",
    "shortDescription": "Used to remove bubbles and smooth surfaces."
  },
  {
    "id": "latex",
    "product_id": 17,
    "name": "Latex",
    "slug": "latex",
    "type": "single",
    "category": "Essential",
    "price": 80,
    "image": "/Updated Products Images/Letex 80₹.webp",
    "description": "Latex material used in mould making and finishing.",
    "shortDescription": "Latex material for mould making."
  },
  {
    "id": "resin-polish",
    "product_id": 20,
    "name": "Resin Polish",
    "slug": "resin-polish",
    "type": "single",
    "category": "Essential",
    "price": 90,
    "image": "/Updated Products Images/Resin polish 90₹.webp",
    "description": "Gives resin products a glossy, professional finish.",
    "shortDescription": "Gives resin products a glossy finish."
  },
  {
    "id": "uv-tape",
    "product_id": 21,
    "name": "UV Tape",
    "slug": "uv-tape",
    "type": "single",
    "category": "Essential",
    "price": 100,
    "image": "/Updated Products Images/Uv tape 100₹.webp",
    "description": "Special tape for UV resin projects.",
    "shortDescription": "Special tape for UV resin."
  },
  {
    "id": "weight-machine",
    "product_id": 22,
    "name": "Weight Machine",
    "slug": "weight-machine",
    "type": "single",
    "category": "Essential",
    "price": 250,
    "image": "/Updated Products Images/Weight machine 250₹.webp",
    "description": "Digital scale for accurate resin measurements.",
    "shortDescription": "Digital scale for accurate measurements."
  },
  {
    "id": "4-kul-embossed-sticker",
    "product_id": 23,
    "name": "4 kul embossed sticker",
    "slug": "4-kul-embossed-sticker",
    "type": "single",
    "category": "Essential",
    "price": 80,
    "image": "/Updated Products Images/New folder/4 kul embossed sticker 80₹.webp",
    "description": "High-quality 4 Kul embossed sticker for resin art and decor.",
    "shortDescription": "High-quality 4 Kul embossed sticker."
  },
  {
    "id": "arabic-sticker",
    "product_id": 24,
    "name": "Arabic sticker",
    "slug": "arabic-sticker",
    "type": "single",
    "category": "Essential",
    "price": 70,
    "image": "/Updated Products Images/New folder/Arabic stickers 70₹.webp",
    "description": "Beautiful Arabic calligraphy sticker for art projects.",
    "shortDescription": "Beautiful Arabic calligraphy sticker."
  },
  {
    "id": "aytal-kursi-embossed-sticker",
    "product_id": 25,
    "name": "Aytal kursi embossed sticker",
    "slug": "aytal-kursi-embossed-sticker",
    "type": "single",
    "category": "Essential",
    "price": 80,
    "image": "/Updated Products Images/New folder/Aytal kursi embossed sticker 80₹.webp",
    "description": "Elegant Aytal Kursi embossed sticker for Islamic art.",
    "shortDescription": "Elegant Aytal Kursi embossed sticker."
  },
  {
    "id": "aytal-kursi-sticker",
    "product_id": 26,
    "name": "Aytal kursi sticker",
    "slug": "aytal-kursi-sticker",
    "type": "single",
    "category": "Essential",
    "price": 80,
    "image": "/Updated Products Images/New folder/Aytal kursi sticker 80₹.webp",
    "description": "Premium Aytal Kursi sticker for resin and framing.",
    "shortDescription": "Premium Aytal Kursi sticker."
  },
  {
    "id": "clock-hands",
    "product_id": 28,
    "name": "Clock Hands",
    "slug": "clock-hands",
    "type": "single",
    "category": "Essential",
    "price": 50,
    "image": "/Updated Products Images/New folder/Clock hands 50₹.webp",
    "description": "Stylish clock hands for DIY resin clocks.",
    "shortDescription": "Stylish clock hands for DIY clocks."
  },
  {
    "id": "clock-machine",
    "product_id": 29,
    "name": "Clock Machine",
    "slug": "clock-machine",
    "type": "single",
    "category": "Essential",
    "price": 120,
    "image": "/Updated Products Images/New folder/Clock machine 120₹.webp",
    "description": "Reliable clock mechanism for custom resin clocks.",
    "shortDescription": "Reliable clock mechanism."
  },
  {
    "id": "resin-clutch",
    "product_id": 30,
    "name": "Resin Clutch",
    "slug": "resin-clutch",
    "type": "single",
    "category": "Essential",
    "price": 800,
    "image": "/Updated Products Images/New folder/Resin clutch 800₹.webp",
    "description": "Fashionable resin clutch frame for handcrafted bags.",
    "shortDescription": "Fashionable resin clutch frame."
  },
  {
    "id": "beginner-kit",
    "product_id": 27,
    "name": "Beginner Kit",
    "slug": "beginner-kit",
    "type": "single",
    "category": "Essential",
    "price": 650,
    "image": "/Updated Products Images/New folder/Beginner kit 650₹.webp",
    "description": "Complete starter kit for resin art beginners.",
    "shortDescription": "Complete starter kit for resin art."
  },
  {
    "id": "acrylic-stand",
    "product_id": 40,
    "name": "Acrylic Stand",
    "slug": "acrylic-stand",
    "type": "size",
    "category": "Stands",
    "image": "/Updated Products Images/New folder (2)/New Essential/Acrylic stand.webp",
    "description": "Clear acrylic stand for displaying small art pieces.",
    "shortDescription": "Clear acrylic stand for display.",
    "sizes": [
      { "label": "4 inch", "price": 40 }
    ]
  },
  {
    "id": "silicon-brush",
    "product_id": 41,
    "name": "Silicon Brush",
    "slug": "silicon-brush",
    "type": "single",
    "category": "Essential",
    "price": 50,
    "image": "/Updated Products Images/New folder (2)/New Essential/Silicon brush.webp",
    "description": "Durable silicon brush for resin application and mixing.",
    "shortDescription": "Durable silicon brush for resin."
  },
  {
    "id": "led-stand",
    "product_id": 42,
    "name": "Led Stand",
    "slug": "led-stand",
    "type": "size",
    "category": "Essential",
    "image": "/Updated Products Images/New folder (2)/New Essential/Led stand.webp",
    "description": "Illuminated LED stand to highlight your resin art.",
    "shortDescription": "Illuminated LED stand to highlight art.",
    "sizes": [
      { "label": "4 inch", "price": 200 },
      { "label": "6 inch", "price": 210 },
      { "label": "8 inch", "price": 230 },
      { "label": "10 inch", "price": 250 },
      { "label": "12 inch", "price": 280 }
    ]
  },
  {
    "id": "jhumka-bezzel",
    "product_id": 16,
    "name": "Jhumka Bezzel",
    "slug": "jhumka-bezzel",
    "type": "single",
    "category": "Jewellery",
    "price": 80,
    "image": "/Updated Products Images/Jhumka bezzel 80₹.webp",
    "description": "Traditional jhumka frames for resin jewelry.",
    "shortDescription": "Traditional jhumka frames."
  },
  {
    "id": "bracelet-bezzel",
    "product_id": 32,
    "name": "Bracelet Bezzel",
    "slug": "bracelet-bezzel",
    "type": "single",
    "category": "Jewellery",
    "price": 120,
    "image": "/Updated Products Images/Bracelet Bezzel 120₹.webp",
    "description": "Elegant bezel for creating custom resin bracelets.",
    "shortDescription": "Elegant bezel for custom resin bracelets."
  },
  {
    "id": "pearl-colour-combo",
    "product_id": 18,
    "name": "Pearl Colour Combo",
    "slug": "pearl-colour-combo",
    "type": "single",
    "category": "Pigments",
    "price": 99,
    "image": "/Updated Products Images/Pearl colour combo 99₹.webp",
    "description": "Premium pearl pigments for resin art.",
    "shortDescription": "Premium pearl pigments."
  },
  {
    "id": "opaque-colour",
    "product_id": 43,
    "name": "Opaque Colour",
    "slug": "opaque-colour",
    "type": "variant",
    "category": "Pigments",
    "image": "/Updated Products Images/New folder (2)/New Pigments/Opaque colour (use this image for all variants).webp",
    "description": "High-quality opaque pigments for solid color resin art.",
    "shortDescription": "High-quality opaque pigments.",
    "variants": [
      { "label": "Black", "price": 55 },
      { "label": "White", "price": 55 },
      { "label": "Red", "price": 55 },
      { "label": "Blue", "price": 55 },
      { "label": "Yellow", "price": 55 },
      { "label": "Green", "price": 55 }
    ]
  },
  {
    "id": "alcohol-ink",
    "product_id": 44,
    "name": "Alcohol Ink",
    "slug": "alcohol-ink",
    "type": "variant",
    "category": "Pigments",
    "image": "/Updated Products Images/New folder (2)/New Pigments/Alcohol ink.webp",
    "description": "Vibrant alcohol inks for creating stunning resin effects.",
    "shortDescription": "Vibrant alcohol inks for resin.",
    "variants": [
      { "label": "Black", "price": 70 },
      { "label": "White", "price": 70 },
      { "label": "Blue", "price": 70 },
      { "label": "Green", "price": 70 },
      { "label": "Red", "price": 70 }
    ]
  },
  {
    "id": "pearl-colour-1",
    "product_id": 451,
    "name": "Pearl Colour 1",
    "slug": "pearl-colour-1",
    "type": "single",
    "category": "Pigments",
    "price": 99,
    "image": "/Updated Products Images/New folder (2)/New Pigments/Pearl colour 1.webp",
    "description": "Shimmering pearl colours for elegant resin finishes.",
    "shortDescription": "Shimmering pearl colours."
  },
  {
    "id": "pearl-colour-2",
    "product_id": 452,
    "name": "Pearl Colour 2",
    "slug": "pearl-colour-2",
    "type": "single",
    "category": "Pigments",
    "price": 99,
    "image": "/Updated Products Images/New folder (2)/New Pigments/Pearl colour 2.webp",
    "description": "Shimmering pearl colours for elegant resin finishes.",
    "shortDescription": "Shimmering pearl colours."
  },
  {
    "id": "pearl-colour-3",
    "product_id": 453,
    "name": "Pearl Colour 3",
    "slug": "pearl-colour-3",
    "type": "single",
    "category": "Pigments",
    "price": 99,
    "image": "/Updated Products Images/New folder (2)/New Pigments/Pearl colour 3.webp",
    "description": "Shimmering pearl colours for elegant resin finishes.",
    "shortDescription": "Shimmering pearl colours."
  },
  {
    "id": "pearl-colour-4",
    "product_id": 454,
    "name": "Pearl Colour 4",
    "slug": "pearl-colour-4",
    "type": "single",
    "category": "Pigments",
    "price": 99,
    "image": "/Updated Products Images/New folder (2)/New Pigments/Pearl colour 4.webp",
    "description": "Shimmering pearl colours for elegant resin finishes.",
    "shortDescription": "Shimmering pearl colours."
  },
  {
    "id": "pearl-colour-5",
    "product_id": 455,
    "name": "Pearl Colour 5",
    "slug": "pearl-colour-5",
    "type": "single",
    "category": "Pigments",
    "price": 99,
    "image": "/Updated Products Images/New folder (2)/New Pigments/Pearl colour 5.webp",
    "description": "Shimmering pearl colours for elegant resin finishes.",
    "shortDescription": "Shimmering pearl colours."
  },
  {
    "id": "pearl-colour-6",
    "product_id": 456,
    "name": "Pearl Colour 6",
    "slug": "pearl-colour-6",
    "type": "single",
    "category": "Pigments",
    "price": 99,
    "image": "/Updated Products Images/New folder (2)/New Pigments/Pearl colour 6.webp",
    "description": "Shimmering pearl colours for elegant resin finishes.",
    "shortDescription": "Shimmering pearl colours."
  },
  {
    "id": "black-mica-powder",
    "product_id": 46,
    "name": "Black Mica Powder",
    "slug": "black-mica-powder",
    "type": "single",
    "category": "Pigments",
    "price": 99,
    "image": "/Updated Products Images/New folder (2)/New Pigments/Black mica powder.webp",
    "description": "Rich black mica powder for deep, metallic effects.",
    "shortDescription": "Rich black mica powder."
  },
  {
    "id": "white-mica-powder",
    "product_id": 47,
    "name": "White Mica Powder",
    "slug": "white-mica-powder",
    "type": "single",
    "category": "Pigments",
    "price": 99,
    "image": "/Updated Products Images/New folder (2)/New Pigments/White mica powder.webp",
    "description": "Sparkling white mica powder for bright, pearlescent effects.",
    "shortDescription": "Sparkling white mica powder."
  },

  {
    "id": "customized-vinyl-stickers",
    "product_id": 50,
    "name": "High Quality Customized Vinyl Stickers",
    "slug": "customized-vinyl-stickers",
    "type": "whatsapp-only",
    "category": "Custom Orders",
    "orderType": "whatsapp",
    "price": null,
    "image": "/Updated Products Images/New folder (2)/WhatsApp Order/Customized Vinyl Stickers/1.webp",
    "images": [
      "/Updated Products Images/New folder (2)/WhatsApp Order/Customized Vinyl Stickers/1.webp",
      "/Updated Products Images/New folder (2)/WhatsApp Order/Customized Vinyl Stickers/2.webp",
      "/Updated Products Images/New folder (2)/WhatsApp Order/Customized Vinyl Stickers/3.webp",
      "/Updated Products Images/New folder (2)/WhatsApp Order/Customized Vinyl Stickers/4.webp"
    ],
    "description": "Get your designs printed on high-quality vinyl stickers! Perfect for branding, gifts, or personal use. Can be customized in black, red, and golden vinyl colors. Contact us on WhatsApp to discuss your custom requirements and get a personalized quote.",
    "shortDescription": "Can be customized in black, red and golden vinyl.",
    "whatsappNumber": "917622073006"
  }
];

// WhatsApp contact number
export const whatsappNumber = '917622073006';

// Function to generate WhatsApp order message
export const getWhatsAppOrderMessage = (productName, variant = null) => {
  let message = `Hello! I'm interested in ordering: ${productName}`;
  if (variant) {
    message += ` (${variant})`;
  }
  return message + `\n\nPlease provide more details about availability and shipping.`;
};

// Function to get product by slug (which is id in the new system)
export const getProductBySlug = (slug) => {
  return products.find(product => product.slug === slug || product.id === slug);
};

// Function to get all product slugs (for routing)
export const getAllProductSlugs = () => {
  return products.map(product => product.slug);
};
